import * as React from 'react';
import * as styles from '../styles.scss';
import { Fallback, QuantityInput } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { IOrderForm, IOrderFormConfig, OrderFormFieldKey } from '../config';
import { FormikErrors } from 'formik';
import { INewSymbolData } from 'interfaces/market';
import { OrderType } from 'constants/enum';

interface IQuantitySectionProps
  extends React.ClassAttributes<QuantityComponent>,
    WithNamespaces {
  readonly config: IOrderFormConfig;
  readonly values: IOrderForm;
  readonly isDerivatives: boolean;
  readonly isStopLimitOrder: boolean;
  readonly isConditionalOrder: boolean;
  readonly isOddlot: boolean;
  readonly maxQty?: number;
  readonly symbol?: INewSymbolData;

  readonly onChangeQuantity: (
    quantity?: number,
    orderQuantityType?: 'share' | 'amount' | 'percentage',
    orderQuantityPercentage?: number
  ) => void;
  readonly onBlurQuantity: (quantity?: number) => void;
  readonly ErrorMessage: React.FC<{
    readonly message?: string ;
  }>;
  readonly errors: FormikErrors<IOrderForm>;
}

class QuantityComponent extends React.Component<IQuantitySectionProps> {

  render() {
    const {
      t,
      config,
      ErrorMessage,
      errors,
      values,
      isDerivatives,
      symbol,
      maxQty,
      isOddlot,
      isConditionalOrder,
      isStopLimitOrder,
      onChangeQuantity,
      onBlurQuantity,
    } = this.props;
    return (
      <>
        {config[OrderFormFieldKey.QUANTITY] != null && (
          <div
            className={classNames(styles.QuantitySection, styles.FormField)}
            style={config[OrderFormFieldKey.QUANTITY]?.style}
          >
            <div className={styles.MainField}>
              <div className={styles.FieldTitle}>{t('Quantity')}</div>
              <div
                className={classNames(styles.FieldInput, styles.MarginTop16, {
                  [styles.HeightQuantityList]:
                    !isDerivatives && values.orderQuantityType === 'share',
                })}
              >
                <QuantityInput
                  data={symbol}
                  onChange={onChangeQuantity}
                  onBlur={onBlurQuantity}
                  percentage={values.orderQuantityPercentage}
                  maxQty={
                    isStopLimitOrder || isConditionalOrder ? undefined : maxQty
                  }
                  value={values.orderQuantity}
                  quantityType={values.orderQuantityType}
                  disableQuantityTypes={
                    isDerivatives || values.orderType !== OrderType.LO
                      ? ['amount']
                      : isStopLimitOrder
                      ? ['percentage']
                      : []
                  }
                  error={errors.orderQuantity != null}
                  isOddlot={isOddlot}
                  disableQuantityType={
                    (isDerivatives && isConditionalOrder) || isOddlot
                  }
                  orderType={values.orderType}
                />
              </div>
            </div>
            <ErrorMessage message={errors.orderQuantity} />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: IState) => ({
  currentSymbol: state.currentSymbol,
  currentSymbolData: state.currentSymbolData,
});

const mapDispatchToProps = {};

const QuantitySection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(QuantityComponent)
  ),
  Fallback,
  handleError
);

export default QuantitySection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/Quantity.tsx